import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function LocalSeo() {
  return (
    <section
      id="service-area"
      data-testid="local-seo-section"
      className="relative py-20 md:py-28 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">
          {/* Content */}
          <div className="flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#D32F2F]" />
              <span className="font-mono-label text-[#D32F2F]">Service Area · Metro Detroit</span>
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[#0B132B] leading-[1.05]">
              Serving <span className="text-[#D32F2F]">Madison Heights</span>{" "}
              and Surrounding Metro Detroit.
            </h2>
            <p className="mt-5 text-[#4A5568] text-lg leading-relaxed">
              Conveniently located on 11 Mile Rd — easy access from I-75, I-696,
              John R Road, and Stephenson Hwy. Drop off your vehicle on the way
              to work and we'll have it ready when you need it.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
              {BUSINESS.serviceAreas.map((area) => (
                <div
                  key={area}
                  data-testid={`service-area-${area.toLowerCase().replace(/\s+/g, "-")}`}
                  className="bg-white px-5 py-4 flex items-center gap-3 hover:bg-[#0B132B] hover:text-white transition-colors group cursor-default"
                >
                  <MapPin className="w-4 h-4 text-[#D32F2F]" strokeWidth={2.5} />
                  <span className="font-semibold text-sm text-[#0B132B] group-hover:text-white">
                    {area}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-8 p-6 bg-[#0B132B] text-white flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <div className="font-mono-label text-[#D32F2F] mb-1">Visit Us</div>
                <div className="font-display text-xl font-semibold">
                  {BUSINESS.address1}
                </div>
                <div className="text-white/75 text-sm">
                  {BUSINESS.city}, {BUSINESS.state} {BUSINESS.zip}
                </div>
              </div>
              <a
                href={BUSINESS.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="directions-btn"
                className="inline-flex items-center justify-center gap-2 bg-[#D32F2F] hover:bg-[#B71C1C] text-white font-semibold py-3 px-6 rounded-none transition-colors"
              >
                <Navigation className="w-4 h-4" strokeWidth={2.5} />
                Get Directions
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="relative border border-[#E2E8F0] bg-white min-h-[500px]">
            <iframe
              title="Veteran's Auto Repair Center location"
              data-testid="google-maps-embed"
              src={BUSINESS.mapsEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
